import { errorToast } from '@/utils';
import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useEffect } from 'react';

export default function useError(
  error: FetchBaseQueryError | SerializedError | undefined,
  message: string,
) {
  useEffect(() => {
    errorToast(error, message);
  }, [error, message]);

  return undefined;
}
